import { InputHTMLAttributes } from 'react';
import styles from './checkbox.module.css';


export function Checkbox(props: InputHTMLAttributes<HTMLInputElement>) {
    return <input {...props} type="checkbox" className={`${props.className ?? ''} ${styles.checkbox}`}/>
}